import React from "react";
import domainHeroRedirect from "../../assets/images/domain/domain-hero-redirect.png";
import { resolvePublicFileUrl } from "../../constants/api-urls";

export default function DomainHeroVisual({ imageUrl = "" }) {
  const customSrc = imageUrl ? resolvePublicFileUrl(imageUrl) : "";
  const src = customSrc || domainHeroRedirect;

  return (
    <div className="hub-domain-hero__visual" aria-hidden>
      <img
        src={src}
        alt=""
        className={`hub-domain-hero__visual-img${customSrc ? " hub-domain-hero__visual-img--custom" : ""}`}
        width={520}
        height={280}
        decoding="async"
      />
    </div>
  );
}
